import * as React from 'react';
import { observer } from 'mobx-react';
import { NotTranslated } from '@execonline-inc/translations';

interface Props {
  firstname: string;
  lastname: string;
  email: string;
}

const SharedRowColumns: React.FC<Props> = ({ firstname, lastname, email }) => (
  <>
    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-900">
      <NotTranslated text={firstname} />
    </td>
    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
      <NotTranslated text={lastname} />
    </td>
    <td className=" whitespace-nowrap px-3 py-4 text-sm text-gray-500">
      <NotTranslated text={email} />
    </td>
  </>
);

export default observer(SharedRowColumns);
